import { checkDynamicCatalogData } from 'domains/ReportBuilder/model/actions';
import { DynamicType } from 'domains/ReportBuilder/types';
import { debounce } from 'lodash';
import { ChangeEvent, useCallback, useEffect } from 'react';
import { useDispatchApp } from 'redux/rootSelectors';
import { useNotExistInCatalogKeys } from 'domains/ReportBuilder/model/selectors';
import { setDefaultNotExistInCatalogKeys } from 'domains/ReportBuilder/reducer';
import { TUseRenderDynamicCatalog } from '../types';

export const useRenderDynamicCatalog: TUseRenderDynamicCatalog = (
  item,
  currentValue,
  currentKey,
  source,
  formikKey,
  formik,
) => {
  const dispatch = useDispatchApp();

  const { data } = item;
  const { data: notExistKeys } = useNotExistInCatalogKeys();

  const dynamicData = data as DynamicType;
  const dynamicValue =
    (formik.values.reportFilters[formikKey][currentKey] as string[]) || [];

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const nextValue = e.target.value.split(',').map((key) => key.trim());

    dispatch(setDefaultNotExistInCatalogKeys());
    formik.setFieldValue(`reportFilters.${formikKey}.${currentKey}`, nextValue);
    handleCheckDynamicCatalogData(source, nextValue, currentKey);
  };

  const debounceCheckDynamicCatalogData = useCallback(
    debounce((type: string, keys: string[], currentKeyParam: string) => {
      dispatch(
        checkDynamicCatalogData({ type, keys, currentKey: currentKeyParam }),
      );
    }, 3000),
    [],
  );

  const handleCheckDynamicCatalogData = useCallback(
    (type: string, keys: string[], currentKeyParam: string) => {
      debounceCheckDynamicCatalogData(type, keys, currentKeyParam);
    },
    [debounceCheckDynamicCatalogData],
  );

  const arraysEqual = (a: string[], b: string[]) =>
    a.length === b.length && a.every((el, i) => el === b[i]);

  useEffect(
    () => () => {
      debounceCheckDynamicCatalogData.cancel();
    },
    [debounceCheckDynamicCatalogData],
  );

  useEffect(() => {
    const currentNotExist = notExistKeys?.[currentKey];
    if (currentNotExist === undefined) return;

    const currentFormikValue =
      (formik.values.reportFilters[formikKey][currentKey] as string[]) || [];

    const filteredItems = currentFormikValue.filter(
      (el) => !currentNotExist.includes(el),
    );

    if (!arraysEqual(filteredItems, currentFormikValue)) {
      formik.setFieldValue(
        `reportFilters.${formikKey}.${currentKey}`,
        filteredItems,
      );
    }
  }, [notExistKeys?.[currentKey], currentKey, formik.values.reportFilters]);

  return {
    dynamicData,
    dynamicValue,
    notExistKeys,
    onChange,
  };
};
